import { updateAuthToken } from '../state/key/keySlice';

const fetchParameter = async (parameterName) => {
    try {
      return process.env.GATSBY_AUTH_TOKEN
    } catch (error) {
      console.error('Error fetching parameter:', error);
      return null;
    }
};

const initializeAuthToken = async (store) => {
    const authToken = await fetchParameter("GATSBY_AUTH_TOKEN_UAT");
    store.dispatch(updateAuthToken(authToken));
}

export {
    initializeAuthToken
};
